import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import EmployeeService from "@/services/employee.service";
import { EmployeeDto } from "@/types/user.type";

@Module({ namespaced: true })
class DentalTemp extends VuexModule {
  employees: EmployeeDto[] = [];

  @Action({ rawError: true })
  async getAllEmployees(): Promise<void> {
    const employees = await EmployeeService.getPracticeEmployeesAsync();
    
    this.context.commit("updateField", {
      path: "employees",
      value: employees
    });
  }

  @Action({ rawError: true })
  async getOfficeEmployees(officeId: number): Promise<void> {
    const employees = await EmployeeService.getOfficeEmployeesAsync(officeId);
    
    const employeeMap = employees.reduce(function(map, obj) {
      map.set(obj.id, obj);
      return map;
    }, new Map());

    for (const employee of this.employees) {
      const e = employeeMap.get(employee.id)
      if (e) {
        employee.isFavorite = e.isFavorite;
        employee.rating = e.rating;
      } else {
        employee.isFavorite = false;
        employee.rating = 0;
      }
    }
  }
}

DentalTemp.getters = { getField };
DentalTemp.mutations = { updateField };

export default DentalTemp;